export type LoginCodeChallenge = {
  pendingToken: string
  codeSentTo: string
}

export class LoginCodeError extends Error {}
